<div class="widget-slider">
  <owl-carousel-o [options]="customOptions">

    <ng-container *ngFor="let imageUrl of widget.data.images">
      <ng-template class="slide" carouselSlide>
        <app-webp-image [src]="getImageUrl(imageUrl)" [alt]="'Das Telemann-Zentrum Magdeburg'"></app-webp-image>
      </ng-template>
    </ng-container>

  </owl-carousel-o>
</div>
